"use strict";
import { devtools } from "zustand/middleware";
import { shallow } from "zustand/shallow";
import { createWithEqualityFn } from "zustand/traditional";
export const useTokenInput = createWithEqualityFn()(
  devtools(
    (set) => ({
      inputCurrency: void 0,
      tokenTradeInput: void 0,
      setInputCurrency: (currency) => set(() => ({ inputCurrency: currency })),
      clearInputCurrency: () => set(() => ({ inputCurrency: void 0 })),
      setTokenTradeInput: (tokenTradeInput) => set(() => ({ tokenTradeInput }))
    }),
    { name: "useTokenInput" }
  ),
  shallow
);
